<div class="w-100">

    <p-steps
        [model]="steps"
        [activeIndex]="activeIndex"
        (activeIndexChange)="onActiveIndexChange($event)">
    </p-steps>

    <div class="step-container">

        <div *ngIf="activeIndex === 0">
            <app-enrollment-edit-step-campus
                [(enrollment)]="enrollment"
                (isCompleteStep)="isCompleteStep = $event">
            </app-enrollment-edit-step-campus>
        </div>

        <div *ngIf="activeIndex === 1">
            <app-enrollment-edit-step-courses
                [(enrollment)]="enrollment"
                (isCompleteStep)="isCompleteStep = $event">
            </app-enrollment-edit-step-courses>
        </div>

        <div *ngIf="activeIndex === 2">
            <app-enrollment-edit-step-discounts
                [(enrollment)]="enrollment"
                (isCompleteStep)="isCompleteStep = $event">
            </app-enrollment-edit-step-discounts>
        </div>

        <div *ngIf="activeIndex === 3">
            <app-enrollment-edit-step-privacy-policy
                [(enrollment)]="enrollment"
                (isCompleteStep)="isCompleteStep = $event">
            </app-enrollment-edit-step-privacy-policy>
        </div>

        <div *ngIf="activeIndex === 4">
            <app-enrollment-edit-step-approbations
                [(enrollment)]="enrollment"
                (isCompleteStep)="isCompleteStep = $event">
            </app-enrollment-edit-step-approbations>
        </div>

        <div *ngIf="activeIndex === 5">
            <app-enrollment-edit-step-summary
                [(enrollment)]="enrollment"
                (isCompleteStep)="isCompleteStep = $event">
            </app-enrollment-edit-step-summary>
        </div>

        <div *ngIf="activeIndex === 6">
            <app-enrollment-edit-step-confirmation
                [enrollment]="enrollment"
                [processResult]="processResult">
            </app-enrollment-edit-step-confirmation>
        </div>

    </div>

    <div class="container-fluid">

        <div [ngClass]="activeIndex > 0 ? 'row justify-content-between' : 'row justify-content-end'">

            <div *ngIf="activeIndex > 0" class="col-12 col-xl-3 mb-2 mb-xl-0">
                <button type="button" class="btn button-accent-color w-100 py-2"
                    (click)="stepButtonClickEvent('previous')">
                    <div class="d-flex flex-row justify-content-center align-items-center w-100">
                        <fa-icon [icon]="['fas', 'arrow-left']"></fa-icon>
                        <span class="fs-6 ms-2">Atrás</span>
                    </div>
                </button>
            </div>

            <div *ngIf="activeIndex < 5" class="col-12 col-xl-3 mb-2 mb-xl-0">
                <button type="button" class="btn button-primary-color w-100 py-2"
                    [disabled]="!isCompleteStep" (click)="stepButtonClickEvent('next')">
                    <div class="d-flex flex-row justify-content-center align-items-center w-100">
                        <span class="fs-6 me-2">Siguiente</span>
                        <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
                    </div>
                </button>
            </div>

            <div *ngIf="activeIndex === 5" class="col-12 col-xl-3 mb-2 mb-xl-0">
                <button type="button" class="btn button-primary-color w-100 py-2"
                    [disabled]="!isCompleteStep || isProcessing" (click)="postEnrollment()">
                    <div *ngIf="!isProcessing" class="w-100">
                        <span class="fs-6 me-2">Crear inscripción</span>
                    </div>
                    <div *ngIf="isProcessing" class="d-flex flex-row justify-content-center align-items-center w-100">
                        <fa-icon [icon]="['fas', 'spinner']" [spin]="true"></fa-icon>
                    </div>
                </button>
            </div>

            <div *ngIf="activeIndex === 6" class="col-12 col-xl-3 mb-2 mb-xl-0">
                <button type="button" class="btn button-primary-color w-100 py-2"
                    [disabled]="!isCompleteStep" (click)="goToEnrollments()">
                    <div class="d-flex flex-row justify-content-center align-items-center w-100">
                        <span class="fs-6 me-2">Finalizar</span>
                        <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
                    </div>
                </button>
            </div>

        </div>

    </div>

</div>
